import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/custom';
// import { Api } from '@/service';
import custom from '@/custom';
import codes from '@/codes';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import partnerList from '../../../Management/partner/partner.List.i18n'
import groupList from '../../../Management/group/group.List.i18n'

//restful api
import { credit as history } from '@/service/api/history'

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

const i18n_fields = {
  EN: [
    { key: 'id', thStyle: 'width: 5%', sortable: true, label: 'No.' },
    { key: 'created_at', thStyle: 'width: 15%', sortable: true, label: 'Date' },
    { key: 'admin', thStyle: 'width: 15%', sortable: true, label: 'Admin(System)'},
    { key: 'partner', thStyle: 'width: 15%', sortable: true, label: 'Partner'},
    { key: 'group', thStyle: 'width: 15%', sortable: true, label: 'Group'},
    { key: 'credit_amount', thStyle: 'width: 10%', sortable: false, label: 'Amount' },
    { key: 'func', sortable: false, label: 'More' },
  ],
  KO: [
    { key: 'id', thStyle: 'width: 5%', sortable: true, label: '#.' },
    { key: 'created_at', thStyle: 'width: 15%', sortable: true, label: '날짜' },
    { key: 'admin', thStyle: 'width: 15%', sortable: true, label: '관리자(시스템)'},
    { key: 'partner', thStyle: 'width: 15%', sortable: true, label: '파트너'},
    { key: 'group', thStyle: 'width: 15%', sortable: true, label: '그룹'},
    { key: 'credit_amount', thStyle: 'width: 10%', sortable: false, label: '비용' },
    { key: 'func', sortable: false, label: '더보기' },
  ]
}

export default {
  components: { DatePicker, vSelect, cSwitch, partnerList, groupList },
  props : ["auto_refresh", "enable_new", "view_detail", "group_id", "partner_id"],
  name : "paymentList",
  data: () => ({
    confirm_payment_history : false,
    payment_history : '',
    loading : false,
    group_name : '',
    chainGroup : false,
    partner_name : '',
    chainPartner : false,
    custom,
    codes,
    datepicker,
    so : default_opt(),
    model : { total : 0, system : 0 },
    sync : { interval : 15, stop : false, th : undefined },
    nbsp : "\u00A0"
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n]
    },
  },
  methods: {
    modal_history(item) {
      if(!item.credit_info) { return this.$toastr.e("no have more information") }
      try { this.payment_history = JSON.parse(item.credit_info) }
      catch (e) { console.debug(e); this.payment_history = item.credit_info }
      this.payment_history.credit_amount = item.credit_amount
      this.confirm_payment_history = true;
      console.log("payment history load", history.length)
    },
    clearChain(type) {
      if(!type) { return this.$toastr.w("require", "clear type") }
      switch (type) {
        case 'partner':
          delete this.so.opt.partner_id
          this.partner_name = '';
          this.chainPartner = false;
          break;
        case 'group':
          delete this.so.opt.group_id
          this.group_name = '';
          this.chainGroup = false;
          break;
        default:
          break;
      }
    },
    setPartner(item) {
      console.log("partner info", item.username, item.id)
      this.so.opt['partner_id'] = item.id
      this.partner_name = item.username;
      this.chainPartner = false;
      this.refresh()
    },
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.so.opt['group_id'] = item.id
      this.group_name = item.groupname;
      this.chainGroup = false;
      this.refresh()
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        // this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'credit_amount'){
        return { name : k, value : parseFloat(v, 10), op : '=' };
      }
      if((k.length > 3 && k.substring(k.length - 3) == "_id") || [].indexOf(k) > -1) {
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true' || (k.length > 2 && k.substring(0, 2) == "is")) {
        return { name : k, value : v === "false" || v === false ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.th) { clearTimeout(this.th); this.th = undefined; }
      if(!this.th && this.sync.stop) { this.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    reset() { this.so = default_opt(); this.group_name = ''; this.partner_name = ''; this.refresh(); },
    refresh() { if(!this.loading && this.$refs._list) { this.$refs._list.refresh(); } },
    getRowCount () { return this.so.totalRows || 0; },
    change($event) { if($event == true || $event == false) { this.so.opt['admin_id'] = $event; this.refresh(); } },
    load(ctx = {}) {
      this.loading = true;
      let so = {
        // target : 'history.credit', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk == 'admin_id') {
        so.body.or.push({ name : this.so.sk, value : 0, op : '=' });
        so.body.or.push({ name : this.so.sk, value : 0, op : 'is null' });
      } else if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 10), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" } }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 10), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" } }
              break;

            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.name == 'admin_id' || cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
        if(this.so.opt['admin_id']) {
          so.body.or.push({ name : 'admin_id', value : 0, op : '=' });
          so.body.or.push({ name : 'admin_id', value : 0, op : 'is null' });
        }
      }
      // return Api.Manager(so).then(rs => {
        return history.listCredit(so).then(rs => {
        this.loading = false
        this.so.totalRows = rs.total; return rs.body;
      }).catch(e => {
        this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
      })
    },
    summary() {
      // Api.Manager({ target : 'history.credit', cmd : 'summary', body : { ts : new Date().getTime() } })
      history.summaryCredit({ ts : new Date().getTime() })
        .then(rs => { this.model = Object.assign(this.model, { total : rs.body.total, system : rs.body.system }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail(item) {
      console.log(item);
      if(this.view_detail === false) { this.$emit("select", item); }
      else { this.$router.push({ name : 'payment', params : { id : item.id } }); }
    },
  },
  created() { console.log('payment_history.vue', 'created'); this.$root.$on('selected', this.setPartner); this.$root.$on('select', this.setGroup); },
  destroyed() { console.log('payment_history.vue', 'destroyed'); },
  mounted() {
    console.log('payment_history.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}